import {internalProps} from '../../../types/BS_types'

const hiddenCloudTypesProp = internalProps['teamcity.cloudProfiles.hiddenCloudTypes']
export const hiddenCloudTypes: ReadonlyArray<string> | null =
  hiddenCloudTypesProp != null && hiddenCloudTypesProp.length > 0
    ? hiddenCloudTypesProp.split(',')
    : null
